import { Sheet } from 'react-modal-sheet';
import { t } from 'i18next';
import { Button, InputBoxSingle } from '@peacecover/component';
import { useBettieProfileUpdateStore } from '../../../presentation/chat/store/useBettieProfileUpdateStore';
import { useIOSKeyboardSheetPadding } from '../../../hooks/useIOSKeyboardSheetPadding';
import { useChangeBettieNickname } from '../../../presentation/chat/hooks/useChangeBettieNickname';
import type { components } from '@pocapan/shared/types/schema';

interface BettieNicknameUpdateBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  bettieProfile: components['schemas']['ApiV1BettieProfile'];
  chatRoomId: string;
}

const BettieNicknameUpdateBottomSheet = ({
  isOpen,
  onClose,
  bettieProfile,
  chatRoomId
}: BettieNicknameUpdateBottomSheetProps) => {
  const { editedNickname, setEditedNickname } = useBettieProfileUpdateStore();
  const { containerRef, handleFocus, handleBlur, handleTouchStart } = useIOSKeyboardSheetPadding();
  const { handleUpdateProfile, isLoading, handleClose } = useChangeBettieNickname({
    chatRoomId,
    onClose
  });

  return (
    <Sheet isOpen={isOpen} onClose={handleClose} detent="content">
      <Sheet.Container className="!rounded-t-[20px] !bg-background-light dark:!bg-background-elevated !pb-0">
        <Sheet.Content ref={containerRef} className="overflow-x-hidden">
          <div className="px-[24px] py-[40px]">
            <div className="flex flex-col items-center gap-[27px]">
              <div className="flex flex-col items-center gap-[8px]">
                <p className="text-[17px] font-bold text-pure-black dark:text-pure-white leading-[20px]">
                  {t('BettieChatRoom.profileUpdateDrawer.title')}
                </p>
                <p className="text-[15px] font-medium text-text-main-lv4 leading-[18px] text-center whitespace-pre-line">
                  {t('BettieChatRoom.profileUpdateDrawer.description')}
                </p>
              </div>
              <div className="flex flex-col items-center gap-[20px] w-full">
                <InputBoxSingle
                  className="w-full bg-transparent"
                  showIcon={true}
                  value={editedNickname}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onTouchStart={handleTouchStart}
                  onChange={(e) => setEditedNickname(e.target.value)}
                  onClear={() => setEditedNickname('')}
                  maxLength={20}
                  placeholder={
                    bettieProfile.nickname ?? t('BettieSetting.bettieUserNickname.placeholder')
                  }
                />
                <div className="mt-[-9px]">
                  <ul className="text-[13px] leading-[20px] text-text-main-lv4 list-disc list-inside">
                    <li>{t('BettieChatRoom.profileUpdateDrawer.remainCharacter')}</li>
                    <li>{t('BettieChatRoom.profileUpdateDrawer.changeChatRoom')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full bg-primary-light pb-[env(safe-area-inset-bottom)]">
            <Button
              size="fill"
              disabled={isLoading}
              onClick={handleUpdateProfile}
              className="text-[17px] font-semibold"
            >
              {t('done')}
            </Button>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onClick={handleClose} className="!bg-[rgba(0,0,0,0.50)]" />
    </Sheet>
  );
};

export default BettieNicknameUpdateBottomSheet;
